/**
 * "Data" gadget (Operate): the project's datastores (vfs-service `GET /data`, shared with Cost), each with its tables
 * (or collections, keys, buckets, topics) and the records the store counts. A store that counts nothing (S3, Kafka) shows
 * no record total rather than a 0. Link: Build › Data.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { formatCount } from '../../../utils/dataModel';
import { dataRows } from '../../../utils/homeGadgets/operate';
import GadgetCard, { GadgetBody, TabLink } from './GadgetCard';
import { useDataOverview } from './sources';

export default function DataGadget({ projectId, onOpenData = null }) {
  const { data, error, loading } = useDataOverview(projectId);
  const rows = dataRows(data);
  return (
    <GadgetCard links={<TabLink onClick={onOpenData}>Build › Data</TabLink>} testId="data-gadget" title="Data">
      <GadgetBody
        data={data}
        empty={rows.length === 0}
        emptyText="This project keeps no data yet."
        error={error}
        errorText="The data could not be read just now."
        loading={loading}
        loadingText="Reading the datastores…"
      >
        {() => (
          <ul className="gd-rows">
            {rows.map((r) => (
              <li className="gd-row" data-testid={`data-${r.id}`} key={r.id}>
                <strong>{r.label}</strong>
                <span className="gd-grow ph-muted">
                  {r.status === 'stopped' ? 'Stopped' : `${formatCount(r.objects)} ${r.noun}`}
                </span>
                {r.status !== 'stopped' && r.records !== null && <span className="gd-num">{formatCount(r.records)} {r.records === 1 ? 'record' : 'records'}</span>}
              </li>
            ))}
          </ul>
        )}
      </GadgetBody>
    </GadgetCard>
  );
}

DataGadget.propTypes = { onOpenData: PropTypes.func, projectId: PropTypes.string.isRequired };
